var render, staticRenderFns
import script from "./UserInfo.vue?vue&type=script&lang=tsx&"
export * from "./UserInfo.vue?vue&type=script&lang=tsx&"
import style0 from "./UserInfo.vue?vue&type=style&index=0&id=08ea44ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ea44ec",
  null
  
)

export default component.exports